import React, { useContext } from "react";
import DataTable from "./components/DataTable";
import SharedDataContext from "../../../SharedDataContext";
import { getCallActivityNumberPerformance } from "../../../apis/callActivity";

export default function NumbersTab({ filters, hasAccess = true }) {
  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};

  const getUserId = () => {
    if (filters.viewToggle === "Individuals") {
      return filters.userTeamSelector;
    }
    return null;
  };

  const getTeamId = () => {
    if (filters.viewToggle === "Team") {
      return filters.userTeamSelector;
    }
    return null;
  };

  const userId = getUserId();
  const teamId = getTeamId();

  const fetchFn = ({ query }) => {
    const params = new URLSearchParams();

    if (filters.dateRange) {
      if (filters.dateRange === "custom") {
        params.set("time_range", "custom");
        if (filters.customStartDate) {
          params.set("start_date", filters.customStartDate);
        }
        if (filters.customEndDate) {
          params.set("end_date", filters.customEndDate);
        }
      } else {
        const dateRangeMap = {
          "7 days": "7d",
          "30 days": "30d",
          "60 days": "60d",
          "90 days": "90d",
          "180 days": "180d",
          "1 year": "1y",
        };
        params.set("time_range", dateRangeMap[filters.dateRange] || "30d");
      }
    }

    return getCallActivityNumberPerformance({
      userId,
      teamId,
      query: params.toString(),
      options: {
        headers: {
          "X-Workspace-Id": activeWorkspace?.id,
          "Content-Type": "application/json",
        },
      },
    });
  };

  return (
    <div className="space-y-6">
      <DataTable
        fetchFn={fetchFn}
        queryKey={["call_activity_number_performance", activeWorkspace?.id, userId, teamId, filters]}
        enabled={!!activeWorkspace?.id && hasAccess}
      />
    </div>
  );
}
